import { marked } from 'marked';
import DOMPurify from 'dompurify';

// Configure marked options
marked.setOptions({
  gfm: true, // GitHub Flavored Markdown
  breaks: true, // Convert \n to <br>
  headerIds: false,
});

export const markdownToHtml = (markdown: string): string => {
  if (!markdown) return '';
  const rawHtml = marked(markdown);
  return DOMPurify.sanitize(rawHtml);
}; 